var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState, useRef, } from 'react';
import cn from 'classnames';
import { Icons } from '@beeline/design-tokens/js/iconfont/icons';
import { IconButton } from '../IconButton';
import { Divider } from '../Divider';
import { SelectDropdown } from '../Select';
import { iconSize } from './constants';
import "./styles.css";
export var Search = React.forwardRef(function (_a, ref) {
    var _b;
    var fullWidth = _a.fullWidth, _c = _a.size, size = _c === void 0 ? 'medium' : _c, className = _a.className, inputClassName = _a.inputClassName, value = _a.value, onSearch = _a.onSearch, onChange = _a.onChange, onKeyUp = _a.onKeyUp, onClear = _a.onClear, filterItems = _a.filterItems, selectedFilter = _a.selectedFilter, onFilterChange = _a.onFilterChange, props = __rest(_a, ["fullWidth", "size", "className", "inputClassName", "value", "onSearch", "onChange", "onKeyUp", "onClear", "filterItems", "selectedFilter", "onFilterChange"]);
    var rootRef = useRef(null);
    var categoriesRef = useRef(null);
    var _d = useState(false), isOpen = _d[0], setOpen = _d[1];
    var _e = useState(value || ''), inputValue = _e[0], setValue = _e[1];
    useEffect(function () {
        setValue(value || '');
    }, [value]);
    var handleOpen = function () { return setOpen(true); };
    var handleClose = function () { return setOpen(false); };
    var inputClasses = cn('lk-ui_search', "lk-ui_search-size__" + size, inputClassName);
    var wrapperClasses = cn('lk-ui_search-wrapper', fullWidth && 'lk-ui_search-wrapper__full', className);
    var handleSearch = function () {
        onSearch === null || onSearch === void 0 ? void 0 : onSearch(inputValue);
    };
    var handleClear = function () {
        setValue('');
        onClear === null || onClear === void 0 ? void 0 : onClear();
    };
    var handleChange = function (event) {
        setValue(event.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    var handleKeyUp = function (event) {
        if (event.key === 'Enter') {
            handleSearch();
        }
        onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(event);
    };
    var makeCategorySelectComponent = function () {
        var rightIcon = (React.createElement(IconButton, { size: size, iconName: isOpen ? Icons.NavArrowUp : Icons.NavArrowDown, onClick: isOpen ? handleClose : handleOpen }));
        var dropdownMenuProps = {
            options: filterItems
                ? __spreadArray([{ id: '$selectAll', value: '-' }], filterItems, true) : [],
            parentRef: rootRef,
            values: selectedFilter ? [selectedFilter] : [],
            onChange: function (_a) {
                var selectedFilter = _a[0];
                onFilterChange === null || onFilterChange === void 0 ? void 0 : onFilterChange(selectedFilter.id !== '$selectAll' ? selectedFilter : null);
                setOpen(false);
            },
            makeOption: function (item) { return React.createElement("span", null, item.value); },
            onOutsideClick: function () { return setOpen(false); },
            multiple: false,
        };
        var classNameLabel = cn({
            'lk-ui_search_categories_label-placeholder': !(selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.value),
        });
        return (React.createElement("div", { className: 'lk-ui_search_categories', ref: categoriesRef, onClick: handleOpen },
            React.createElement(Divider, { className: 'lk-ui_search_categories_vertical-divider' }),
            React.createElement("span", { className: classNameLabel }, (selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.value) || 'Категории'),
            rightIcon,
            isOpen && React.createElement(SelectDropdown, __assign({}, dropdownMenuProps))));
    };
    var leftCategory = (_b = categoriesRef === null || categoriesRef === void 0 ? void 0 : categoriesRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth;
    var rightCloseButton = leftCategory ? leftCategory + 16 : 16;
    return (React.createElement("span", { className: wrapperClasses, ref: rootRef },
        React.createElement(IconButton, { iconName: Icons.Search, className: 'lk-ui_search-button', size: iconSize[size], onClick: handleSearch }),
        React.createElement("input", __assign({ ref: ref }, props, { onKeyUp: handleKeyUp, onChange: handleChange, value: inputValue, className: inputClasses, autoComplete: 'off', type: 'search', style: { paddingRight: leftCategory + "px" } })),
        inputValue && (React.createElement(IconButton, { iconName: Icons.Close, className: 'lk-ui_search-close-button', style: { right: rightCloseButton + "px" }, size: iconSize[size], onClick: handleClear })),
        filterItems && makeCategorySelectComponent()));
});
